export class SupplierContactBE {
    Id: number = -1;
    SupplierId: number = -1;
    Name: string = "";
    Email: string = "";
    Phone: string = "";
    UseInApprovalFlow: boolean = true;
    dirty: boolean = false;
    IsSparePart:number = 2 ;
    IsMailSendForActive: boolean = true;
    IsMailSendForPHC: boolean = true;
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/supplier-contact/shared/supplier-contact.model.ts